import React from 'react';
import { useSearchParams } from 'react-router-dom';
import IELTSCourse from './IELTSCourse';
import { task1OverviewData, getDataForDifficulty } from './data/skills/writing/task1Overview';

export default function Task1Overview() {
  const [searchParams] = useSearchParams();
  const lessonId = searchParams.get('lessonId');
  const difficulty = parseInt(searchParams.get('difficulty')) || 3;

  return (
    <IELTSCourse
      {...(difficulty !== 3 ? getDataForDifficulty(difficulty) : task1OverviewData)}
      lessonId={lessonId}
      difficulty={difficulty}
    />
  );
}
